import "../../../../App.css";
import "../../../_Shared/utility.css";
import "./PatientResources.css";
import { FRBanner } from "../../../Banner/Banner.js";
import ReactTooltip from "react-tooltip";
import { Helmet } from "react-helmet-async";
import { cdn } from "../../../../consts/cdn.js";
import {
  slide1FR,
  PatientResourcesSlidesFR,
} from "../../../Carousel/CarouselData.js";
import Carousel from "../../../Carousel/Carousel.js";
import { JwPlayer } from "../../../JwPlayer/JwPlayer.js";

//Images
const BannerDesktop = cdn.images + "Patients/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "Patients/Banner-Mobile.jpg";
const Image1a = cdn.images + "Patients/Image1a.jpg";
const Image1b = cdn.images + "Patients/Image1b.jpg";
const Image1c = cdn.images + "Patients/Image1c.jpg";
const Image1d = cdn.images + "Patients/Image1d.jpg";

const CircleBackgroundDesktopLeft =
  cdn.images + "Patients/CircleBackground-Left-Desktop.png";
const CircleBackgroundMobileLeft =
  cdn.images + "Patients/CircleBackground-Left-Mobile.png";

function PatientResources() {
  return (
    <div className="patients">
      <Helmet>
        <title>vNOTES Hysterectomy</title>
        <meta
          name="description"
          content="vNOTES (vaginal natural orifice transluminal endoscopic surgery) is another minimally invasive approach to consider for your hysterectomy and other gynecologic…"
        />
      </Helmet>
      <FRBanner
        imgdesktop={BannerDesktop}
        imgmobile={BannerMobile}
        boldTitle1="UNE OPTION"
        boldTitle2="DIFFÉRENTE POUR"
        boldTitle3="L'HYSTÉRECTOMIE"
        subtitle="Présenter le vNOTES aux patientes comme une autre approche de l'hystérectomie."
        color="#EA6100"
      />
      <div className="content">
         <JwPlayer
                file="https://ep-appliedmediaservice-ammedia-mediakind.westus2.streaming.mediakind.com/4ebad688-e2c8-4263-997f-6afe65059ddd/701122-FR-A vNOTES A Scarless Hy.ism/manifest(format=m3u8-cmaf)"
                title="vNOTES Patient-Facing"
                autostart="true"
                ></JwPlayer>
        <div className="hcphome__extrapadding">
          <h1 className="header-primary header-primary--orange header-primary--comfortaa">
            QU'EST-CE QUE LE{" "}
            <span
              style={{ textTransform: "lowercase", fontFamily: "Comfortaa" }}
            >
              v
            </span>
            NOTES ?
          </h1>
          <p className="paragraph">
            Si une hystérectomie a été recommandée pour traiter une pathologie - telle que des douleurs pelviennes, des règles abondantes ou un prolapsus de l'utérus &ndash;{" "} L'approche {" "}
            <span style={{ color: "#EA6100", fontWeight: "700" }}>vNOTES</span>{" "}
            (vaginal natural orifice transluminal endoscopic surgery - chirurgie vaginale endoscopique par voie naturelle) peut être une option. Lors d'une intervention par{" "}
            <span style={{ color: "#EA6100", fontWeight: "700" }}>vNOTES</span>{" "}
            , des instruments spécialisés sont insérés par le vagin au lieu de pratiquer des incisions dans l'abdomen.
          </p>
        </div>
        <div className="patients__img-container patients__img-container--1">
          <div className="patients__img-flex-item">
            <img
              className="patients__img--1"
              src={Image1a}
              alt="OChirurgie ouverte"
              loading="lazy"
            />
            <div className="patients__img-caption">Chirurgie ouverte</div>
          </div>
          <div className="patients__img-flex-item">
            <img
              className="patients__img--1"
              src={Image1b}
              alt="Chirurgie laparoscopique"
              loading="lazy"
            />
            <div className="patients__img-caption">Chirurgie laparoscopique</div>
          </div>
          <div className="patients__img-flex-item">
            <img
              className="patients__img--1"
              src={Image1d}
              alt="Chirurgie robotique"
              loading="lazy"
            />
            <div className="patients__img-caption">Chirurgie robotique</div>
          </div>
          <div className="patients__img-flex-item">
            <img
              className="patients__img--1"
              src={Image1c}
              alt="vNOTES"
              loading="lazy"
            />
            <div className="patients__img-caption" style={{ color: "#4B759D" }}>
              vNOTES
            </div>
          </div>
        </div>

         <br className="br__desktop-only" />

        <div className="hcphome__extrapadding">
          <p className="paragraph">
            Outre les hystérectomies, l'approche{" "}
            <span style={{ color: "#EA6100", fontWeight: "700" }}>vNOTES</span>{" "}
            peut être utilisée pour d'autres interventions gynécologiques :
          </p>

          <ul className="patients__list">
            <li>
              <p className="paragraph">Interventions sur les trompes de Fallope ou les ovaires</p>
            </li>
            <li>
              <p className="paragraph">Stérilisation permanente</p>
            </li>
            <li>
              <p className="paragraph">Réparation du prolapsus de l'organe pelvien</p>
            </li>
          </ul>
        </div>
      </div>

      <div className="patients__section" style={{ background: "#fafafa" }}>
        <div className="patients__half-text hcphome__extrapadding">
          <h1
            className="header-primary--orange header-primary--comfortaa"
            style={{ margin: "0px" }}
          >
            LE vNOTES FOURNIT <br className="br__mobile-only" /> LES{" "} 
            <br className="br__desktop-only" />
            AVANTAGES SUIVANTS PAR{" "}
            <br className="br__desktop-only" />
            RAPPORT <br className="br__mobile-only" /> À LA CHIRURGIE 
            <br className="br__desktop-only" />
            {" "}LAPAROSCOPIQUE{" "}
            <sup
              className="ref__style patients__header-ref"
              data-background-color="#FAFAFA"
              data-text-color="#707070"
              data-tip="Baekelandt JF, De Mulder PA, Le Roy I, et al. Hysterectomy by transvaginal natural orifice transluminal endoscopic surgery versus laparoscopy as a day-care procedure: a randomised controlled trial. <i>BJOG</i>. 2019;126(1):105-113.<br/>doi:10.1111/1471-0528.15504"
              data-class="sup__style"
              data-arrow-color="transparent"
              data-html="true"
            >
              REF
            </sup>
            {" "}:
          </h1>
        </div>
        <div className="patients__half-img hcphome__extrapadding">
          <Carousel data={slide1FR} carousel_name="benefits-carousel" autoplay />
        </div>
      </div>

      <div className="vnotes-expect-container">
        <div
          className="content hcphome__right-content vnotes-expect-content"
          style={{
            position: "absolute",
            textAlign: "right"
          }}
        >
          <h1
            className="header-primary header-primary--orange header-primary--comfortaa vnotes-expect-header"
            style={{ margin: "0px" }}
          >
            CE QUE LES<br className="br__mobile-only" /> PATIENTES<br className="br__mobile-only" />
            <br className="br__desktop-only" />
            PEUVENT <br className="br__mobile-only" /> ATTENDRE{" "} 
            <br className="br__desktop-only" />
            DE<br className="br__mobile-only" /> LA VOIE{" "}  

            <span
              style={{ textTransform: "lowercase", fontFamily: "Comfortaa" }}
            >
              v
            </span>
            NOTES.{" "}
          </h1>
          <p className="vnotes-expect-subheader">
            Le vNOTES peut ne pas convenir à toutes les patientes. Il est <br className="vnotes-expect-desktop-break" />
            important d'informer les patientes que le vNOTES, comme toutes les <br className="vnotes-expect-desktop-break" />
            chirurgies, comporte des risques, y compris la possibilité d'une <br className="vnotes-expect-desktop-break" />
            conversion aux techniques traditionnelles.
          </p>
        </div>
        <img
          className="banner__img banner__img--desktop patients__banner--desktop"
          src={CircleBackgroundDesktopLeft}
          alt=""
          style={{ aspectRatio: "auto" }}
        />
        <img
          className="banner__img banner__img--mobile"
          src={CircleBackgroundMobileLeft}
          alt=""
          style={{ aspectRatio: "auto" }}
        />
      </div>
      <div
        className="content content--carousel"
        style={{
          marginTop: "0px",
          marginBottom: "0px",
          backgroundColor: "rgb(250, 250, 250)",
        }}
      >
        <Carousel
          data={PatientResourcesSlidesFR}
          carousel_name="procedure-carousel"
          singleImage
        />
      </div>

      <ReactTooltip />
    </div>
  );
}

export default PatientResources;
